'use strict';

import { Entity } from '../Entity';
import { User } from './User';

export class UserClientPortal extends Entity {
  protected id;

  protected user: User;

  protected portalName;

  protected portalContent = [];

  protected portalIntroText;

  protected noDisclosure;

  protected portalColor;

  protected portalLogo;

  protected forNew;

  protected portalDisclosure;

  protected calendarEmbed;

  protected agencyShare;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.user = data.user;

    this.portalName = data.portalName;

    this.portalContent = data.portalContent;

    this.portalIntroText = data.portalIntroText;

    this.noDisclosure = data.noDisclosure;

    this.portalColor = data.portalColor;

    this.portalLogo = data.portalLogo;

    this.forNew = data.forNew;

    this.portalDisclosure = data.portalDisclosure;

    this.calendarEmbed = data.calendarEmbed;

    this.agencyShare = data.agencyShare;

    if (data.user) {
      const user = new User();

      user.hydrate(data.user);

      this.user = user;
    }
  }

  public getId() {
    return this.id;
  }

  public getUser() {
    return this.user;
  }

  public getPortalName() {
    return this.portalName;
  }

  public getPortalContent() {
    return this.portalContent;
  }

  public getPortalIntroText() {
    return this.portalIntroText;
  }

  public getNoDisclosure() {
    return this.noDisclosure;
  }

  public getPortalColor() {
    return this.portalColor;
  }

  public getPortalLogo() {
    return this.portalLogo;
  }

  public getForNew() {
    return this.forNew;
  }

  public getPortalDisclosure() {
    return this.portalDisclosure;
  }

  public getCalendarEmbed() {
    return this.calendarEmbed;
  }

  public getAgencyShare() {
    return this.agencyShare;
  }

  public getCalendarEmbedEscaped() {
    if (this.calendarEmbed) {
      return this.calendarEmbed
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    return this.calendarEmbed;
  }
}
